import ResetPasswordPanel from './ResetPasswordPanel';

export default ResetPasswordPanel;
